import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0763f084"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow flex-col grid grid-cols-1 sm:grid-cols-9 gap-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1 text-center self-start flex flex-row px-4 sm:p-0 mb-8 sm:mb-0 items-center sm:items-start justify-between" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/pilogowhite.png",
    alt: "Pi logo white",
    class: "w-1/3 sm:w-3/4"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/bioplastics/bpelogo.png",
    class: "w-1/3 inline-block sm:hidden",
    alt: "Logo"
  })
], -1))
const _hoisted_3 = { class: "sm:col-span-5 flex flex-row items-center" }
const _hoisted_4 = { class: "text-5xl font-bold text-project2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-3 hidden sm:flex flex-row justify-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/bioplastics/bpelogo.png",
    class: "max-h-48 max-w-48",
    alt: "Logo"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_7 = { class: "sm:col-span-5" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-3 flex flex-col justify-end items-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/bioplastics/cuttlery.png",
    class: "w-full",
    alt: "Logo"
  })
], -1))
const _hoisted_12 = { class: "flex flex-col sm:flex-row mt-auto bg-white absolute bottom-0 left-0 right-0 p-4 text-black text-xs" }
const _hoisted_13 = { class: "flex flex-row flex-1 items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/eu.logo.png",
  alt: "EU Flag",
  class: "h-12 align-top mr-2 w-auto"
}, null, -1))
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "flex-1 flex flex-row sm:ml-2 text-center sm:text-right mt-4 sm:mt-0 items-center justify-center sm:justify-end" }
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content relative", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0 pb-12",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("h2", _hoisted_4, null, 512), [
              [_directive_t, _ctx.config.title]
            ])
          ]),
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", {
              class: "mt-8",
              innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_8),
            _createElementVNode("p", {
              class: "mt-8",
              innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_9),
            _createElementVNode("p", {
              class: "mt-8",
              innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_10),
            _createVNode(_component_ActionButton, {
              text: "buttons.start",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.next())),
              class: _normalizeClass(["mt-8 mx-auto sm:mx-0 block action-button-primary", _ctx.config.classes?.buttonClasses])
            }, null, 8, ["class"])
          ]),
          _hoisted_11
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", {
          innerHTML: _ctx.$t('BIOPLASTICS_INTRO.eu-footer')
        }, null, 8, _hoisted_15)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", {
          innerHTML: _ctx.$t(_ctx.config.textPart4)
        }, null, 8, _hoisted_17)
      ])
    ])
  ], 2))
}